import React, {useCallback, useState} from 'react';

import RenderItemDetails from './RenderItemDetails';
import {Layout, Table, Text} from '@phonectas/unifon-ui-kit';
import SearchWidget from 'common/components/SearchWidget';
import {useTranslation} from 'react-i18next';
import {LIMIT_PAYLOAD} from 'services/constants';
import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {shallow} from 'zustand/shallow';
import {StyledSectionDiv} from '../components/styled';
import {CustomerRespList} from './types';
// import CustomLoader from 'common/components/customLoader';

const ResponsibleTab: React.FC = () => {
	const [t] = useTranslation();
	const {
		majorResponsibleSearch,
		majorResponsibleList,
	} = useThreeSixtyNewStore((state) => ({
		majorResponsibleSearch: state.majorResponsibleSearch,
		majorResponsibleList: state.majorResponsibleList,
	}), shallow);
	const majorCustomerList = useThreeSixtyNewStore((state) => state?.customerResponibles);
	// const isLoading = useThreeSixtyNewStore((state) => state?.isLoading);
	const majorList = majorCustomerList?.customer_resps;
	const [selectedItem, setSelectedItem] = useState<CustomerRespList | null>(null);
	const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
	const [searchQuery, setSearchQuery] = useState<string>('');

	const handleRowClick = useCallback((index: number, item: CustomerRespList) => {
		setSelectedIndex(index);
		setSelectedItem(item);
		majorResponsibleSearch({entraId: item?.entra_id});
	}, [majorResponsibleSearch, setSelectedItem]);

	const handleSearchQuery = useCallback((value: string) => {
		majorResponsibleList({search: value});
	}, [majorResponsibleList]);

	const handleCrearQuery = useCallback(() => {
		setSearchQuery('');
		majorResponsibleList({limit: LIMIT_PAYLOAD});
	}, [majorResponsibleList]);

	const renderItem = useCallback((item: CustomerRespList, index: number) => (
		<Table.Row
			key={index}
			style={{padding: '0 16px'}}
			index={index}
			onClick={() => handleRowClick(index, item)}
			selected={index === selectedIndex}
		>
			<Table.Cell><Text>{item?.name}</Text></Table.Cell>
			<Table.Cell><Text>{item?.mobiles_count}</Text></Table.Cell>
			<Table.Cell><Text>{item?.customers_count}</Text></Table.Cell>
		</Table.Row>
	), [selectedIndex, handleRowClick]);

	return (
		<Layout nowrap fullWidth fullHeight style={{overflow: 'hidden'}}>
			<StyledSectionDiv
				style={{
					maxWidth: '60%',
					display: 'flex',
					flexWrap: 'nowrap',
					flexDirection: 'column',
					height: '100%',
					overflow: 'hidden',
					gap: '10px',
				}}
			>
				<Layout direction="row" fullWidth>
					<SearchWidget
						placeholder={t('Search for major customer responsible')}
						fullWidth
						value={searchQuery}
						onChange={handleSearchQuery}
						clearSearch={handleCrearQuery}

					/>
				</Layout>
				<Layout
					direction="row"
					autoOverflow
					fullWidth
					fullHeight
					style={{paddingBottom: '40px'}}
				>
					<Table
						items={majorList || []}
						renderItem={renderItem}
					>
						<Table.Row
							style={{padding: '0 16px'}}
						>
							<Table.Cell>{t('Name')}</Table.Cell>
							<Table.Cell width={120}>{t('Mobiles')}</Table.Cell>
							<Table.Cell width={60}>{t('Quantity')}</Table.Cell>
						</Table.Row>
					</Table>
				</Layout>
			</StyledSectionDiv>
			{
				selectedItem !== null ? (
					<StyledSectionDiv
						style={{
							maxWidth: '50%',
							display: 'flex',
							flexWrap: 'nowrap',
							flexDirection: 'column',
							height: '100%',
							overflow: 'hidden',
							gap: '10px',
						}}
					>

						<RenderItemDetails data={selectedItem}/>
					</StyledSectionDiv>
				) :
					(
						<StyledSectionDiv>
							<Layout fullWidth gap="sm">
								<Text variant="h5">
									{t('Select a major customer responsible to see details')}
								</Text>
							</Layout>
						</StyledSectionDiv>
					)
			}
			{/* <CustomLoader advanced isLoading={isLoading} /> */}
		</Layout>
	);
}

export default ResponsibleTab;
